import { render, staticRenderFns } from "./TableListTags.vue?vue&type=template&id=567bc5d8"
import script from "./TableListTags.vue?vue&type=script&lang=js"
export * from "./TableListTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0___c7f2b04d8b701f96d19063791ac122bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports